import { render, staticRenderFns } from "./TabResetPassword.vue?vue&type=template&id=6ee456ae&scoped=true&"
import script from "./TabResetPassword.vue?vue&type=script&lang=js&"
export * from "./TabResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./TabResetPassword.vue?vue&type=style&index=0&id=6ee456ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee456ae",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/Settings/TabResetPassword.vue
// module id = 927
// module chunks = 0